import type { CoverShipmentAttachmentItem } from '../../cover-shipments/cover-shipments-shared.dto.js';
import type {
  ShipmentBuilderInput,
  ShipmentTotalsSummary,
} from '../../shipments/shipments-shared.dto.js';
import type { CounterpartySnapshot } from '../../counterparties/counterparties.dto.js';
import type { CoverSourcePreparationRequestDetail } from '../../source-preparation/source-preparation.dto.js';

export const coverShipmentSyncEntityTypeValues = ['coverShipment'] as const;
export type CoverShipmentSyncEntityType = (typeof coverShipmentSyncEntityTypeValues)[number];

export const coverShipmentSyncEventTypeValues = [
  'coverShipmentSaved',
  'coverShipmentVoided',
  'coverShipmentEvidenceUpdated',
  'coverShipmentDeparted',
] as const;
export type CoverShipmentSyncEventType = (typeof coverShipmentSyncEventTypeValues)[number];

export interface CoverShipmentSyncPayloadBase {
  schemaVersion: 1;
  eventId: string;
  occurredAt: string;
  companyId: string;
  stationId: string;
  coverShipmentId: string;
}

export interface CoverShipmentSavedEventPayload extends CoverShipmentSyncPayloadBase {
  actorUserId: string | null;
  materialId: string;
  shipper: CounterpartySnapshot;
  receiver: CounterpartySnapshot;
  builderInput: ShipmentBuilderInput;
  sourcePreparationRequestId?: string | null;
  sourcePreparationSnapshotJson?: CoverSourcePreparationRequestDetail | null;
  attachments: CoverShipmentAttachmentItem[];
  ownPurchaseLineItemIds: string[];
  purchaseCommittedIds: string[];
  sourceLoadSessionId?: string | null;
  sourceLoadSessionGroupId?: string | null;
  departedAt?: string | null;
  totals: ShipmentTotalsSummary;
}

export interface CoverShipmentVoidedEventPayload extends CoverShipmentSyncPayloadBase {
  actorUserId: string | null;
  reason: string;
}

export interface CoverShipmentEvidenceUpdatedEventPayload extends CoverShipmentSyncPayloadBase {
  actorUserId: string | null;
  sourceLoadSessionId?: string | null;
  sourceLoadSessionGroupId?: string | null;
}

export interface CoverShipmentDepartedEventPayload extends CoverShipmentSyncPayloadBase {
  actorUserId: string | null;
  departedAt: string;
}
